import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ab7b873"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "设置", -1))
const _hoisted_5 = { class: "sys-menu" }
const _hoisted_6 = { class: "right" }

import Top from "@/components/Top.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 20 }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_scrollbar, { class: "list" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: '/index/system/user',
                class: "block"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 个人信息 ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Top),
      _createVNode(_component_router_view, { class: "main-view" }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})